

import { Constants } from './Constants';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'datemon',
  pure: true
})
export class DateMon extends DatePipe implements PipeTransform {
  
  override transform(value: any, args?: any): any {
    if(value != undefined){
    var dateStr = value.replace('00:00:00.0', '');
    try{
    var result = super.transform(dateStr, Constants.DATE_TIME_FMT)
    }catch (Exception){}
    return result;
  }
}
}